import React, { useState, useEffect } from 'react'
// import '../css/reOrder.css'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'

import logo from '../img/logo2.png'
import { apiRequest } from '../utils/apiCalls'
import { Modal, Button, Form, Col, Row, Container } from 'react-bootstrap'
import { AppColors } from '../css/AppColors';
import { FaLastfmSquare } from 'react-icons/fa'
import { useParams } from 'react-router'
import OrderPlacedImg from '../img/orderplaced.png';

const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return React.useCallback(() => updateState({}), []);
}




const ReOrder = (props) => {

    const forceUpdate = useForceUpdate();
    const [loading, setLoading] = useState(false)
    const [prod, setProd] = useState();
    const [cust_id, setCust_id] = useState(props.match.params.cust_id)
    const [presc, setPresc] = useState({});
    const [oi_items, setOi_items] = useState({
        p_id: props.match.params.p_id, //product id
        oi_prod: '', // product name
        oi_odos: '',
        oi_sph: '',
        oi_cyl: '',
        oi_axis: '',
        oi_prism: '',
        oi_fi: '',
        oi_ct: '',
        oi_expiry: '', // product expiry
        p_exp_days : 0, //exp_no_days
        oi_unit_price: '', // MSRP
        oi_qty: '', // order item quantity
        oi_amount: '', // order item net price,
        oi_prom_id: '',
        oi_prom_name: '',

        prom_apply: false, //onlye used in interface
        prom_name: '',
        prod_prom: [], // only used in interface
        prom_discount: '',// only used interface

    })
    const [tempPromId, setTempPromId] = useState()
    const [promotions, setPromotions] = useState([])
    const [cust, setCust] = useState()
    const [ordered, setOrdered] = useState(false)
    const [error, setError] = useState('')


    function getProducts(index) {

        setLoading(true)
        const reqObj = {
            p_id: props.match.params.p_id,
            cust_id: props.match.params.cust_id,
            oi_id: props.match.params.oi_id,

        }
        console.log(reqObj)
        apiRequest(reqObj, 'get_reorder_info')
            .then(data => {
                console.log(data)
                if (data.status == '1') {
                    let oi_items = data.data.oi_items
                    // console.log('prod are')
                    // console.log(products)
                    if (oi_items.length == 0) {
                        setError('No order exists')
                        return
                    }
                    setProd(data.data.products[0])
                    setCust(data.data.customer[0])
                    setPromotions(data.data.promotions)
                    console.log(data)
                    setOi_items({
                        ...oi_items,
                        oi_prod: data.data.products[0].p_name,
                        oi_unit_price: data.data.products[0].p_MSRP,
                        oi_expiry: parseInt(data.data.products[0].p_age) + parseInt(1),
                        p_exp_days : parseInt(data.data.products[0].exp_no_days), //
                        oi_odos: data.data.oi_items[0].oi_odos,
                        oi_sph: data.data.oi_items[0].oi_sph,
                        oi_cyl: data.data.oi_items[0].oi_cyl,
                        oi_axis: data.data.oi_items[0].oi_axis,
                        oi_prism: data.data.oi_items[0].oi_prism,
                        oi_fi: data.data.oi_items[0].oi_fi,
                        oi_ct: data.data.oi_items[0].oi_ct,
                        oi_qty: data.data.oi_items[0].oi_qty,
                        prom_discount: data.data.oi_items[0].oi_discount,
                        oi_amount: data.data.oi_items[0].oi_amount,
                        oi_prom_id: data.data.oi_items[0].oi_prom_id
                    })
                    setTempPromId(data.data.oi_items[0].oi_prom_id)
                    forceUpdate();
                    setLoading(false)
                }
                else {
                    if (data.error == '404') setError(data.msg);
                    // alert(data.error)
                    setLoading(false)
                }
            })
            .catch(err => {

                setLoading(false)
                alert('Internet error')
                console.log(err)
            })
    }

    function addOrder() {

        setLoading(true)
        // var o_item = {};
        var o_itemArr = oi_items;
        const reqObj = {
            st_id: props.match.params.st_id,
            cust_id: props.match.params.cust_id,
            o_amount: oi_items.oi_amount,
            o_items: o_itemArr,
        }

        // console.log('my final object is')
        // console.log(reqObj)

        apiRequest(reqObj, 'addOrderByCust')
            .then(data => {
                console.log(data)
                setLoading(false)
                if (data.status == '1') {
                    setOrdered(true)
                    // alert(data.msg)
                }
                else alert(data.error)
                console.log(data)
            })
    }



    useEffect(() => {
        getProducts()
    }, [])


    if (error) {
        return (
            <div
                className="container container-fluid"
                style={{ padding: "0px 0px 0px 0px" }}
            >


                <div className="row">
                    <div className="container-fluid" >
                        <div className="col-lg-12">
                            <div className="jumbotron text-center flux">
                                <p>
                                    {error}
                                    {/* Welcome <strong>{cust?.cust_fname} {cust?.cust_lname} </strong> */}
                                </p>

                            </div>
                        </div>
                        {/* <h1>{error}</h1> */}
                    </div>
                </div>
            </div>
        )
    }
    else if (ordered) {
        return (
            <Container style={{ textAlign: 'center', marginTop: 150 }}>
                <img
                    src={logo}
                    className="text-center"
                    alt="Product Image"
                />
                {/* <img
                    src={OrderPlacedImg} style={{ width: "10%", }} alt="Remeyend"
                /> */}
                <div style={{ marginTop: 30, fontSize: 25, color: AppColors.primary, fontFamily: 'PBo', }}>Order Confirmation</div>
                <div style={{ fontSize: 20, color: AppColors.primary, fontFamily: 'PMe', marginTop: 10 }}>Thank you for placing order with us</div>
            </Container>
        )
    }
    else return (
        <div
            className="container container-fluid"
            style={{ padding: "0px 0px 0px 0px" }}
        >

            <div className="row">
                <div className="container-fluid" >
                    <Modal

                        show={loading}
                        onHide={() => setLoading(false)}
                    >

                        <Modal.Body class="text-center" >
                            <div
                                class="text-center"
                                class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                        </Modal.Body>

                    </Modal>
                </div>
                <div className="col-lg-12">
                    <div className="jumbotron text-center flux">
                        <p>
                            Welcome <strong>{cust?.cust_fname} {cust?.cust_lname} </strong>
                        </p>
                        <img
                            src={logo}
                            className="text-center"
                            alt="Product Image"
                        />
                        <br />
                        <h1 className="text-center" style={{ fontSize: 20 }} >{prod?.p_name} </h1>
                        <div className="text-center">
                            <p>Unit Price: ${prod?.p_MSRP}</p>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-3 col-md-3 col-sm-6 float-left">
                                <label className="form-group text-center">
                                    Qty
                                    <br />
                                    <input
                                        type="number"
                                        className="form-control text-center"
                                        name="quantity"
                                        value={oi_items.oi_qty}
                                        // disabled={oi_items.prom_apply ? true : false}
                                        min={0}
                                        defaultValue={1}
                                        onChange={(v) => {
                                            if (v.target.value == '') {
                                                setOi_items({
                                                    ...oi_items,
                                                    oi_qty: v.target.value,
                                                    oi_amount: 0,

                                                    oi_prom_id: '',
                                                    oi_prom_name: '',
                                                    prom_name: '',
                                                    prom_discount: '0',
                                                    prom_apply: false

                                                })
                                            }
                                            else {
                                                const checkPromotionApplicable = promotions.find(item => item.prom_qty == v.target.value);
                                                console.log('console 1');
                                                console.log(checkPromotionApplicable);
                                                if (checkPromotionApplicable) {
                                                    var obj = checkPromotionApplicable
                                                    var makeDiscountString;
                                                    if (obj.prom_type == 'fixed') makeDiscountString = "$" + obj.prom_amount;
                                                    else makeDiscountString = obj.prom_amount + "%"
                                                    setOi_items({
                                                        ...oi_items,
                                                        oi_prom_id: obj.prom_id,
                                                        prom_name: obj.prom_name,
                                                        oi_prom_name: obj.prom_name,
                                                        oi_qty: obj.prom_qty,
                                                        oi_amount: obj.prom_price,
                                                        prom_discount: makeDiscountString,
                                                        prom_apply: true
                                                    })
                                                }

                                                else setOi_items({
                                                    ...oi_items,
                                                    oi_qty: v.target.value,
                                                    oi_amount: (parseInt(v.target.value) * 1) * parseInt(prod.p_MSRP),

                                                    oi_prom_id: '',
                                                    oi_prom_name: '',
                                                    prom_name: '',
                                                    prom_discount: '0',
                                                    prom_apply: false
                                                })
                                            }

                                            // setOi_items({
                                            //     ...oi_items,
                                            //     oi_prom_id: '',
                                            //     oi_prom_name : '',
                                            //     prom_name: '',
                                            //     oi_qty: '',
                                            //     oi_amount: '',
                                            //     prom_discount: '',
                                            //     prom_apply: false
                                            // })
                                            forceUpdate();


                                        }}

                                    />
                                </label>
                            </div>
                            <div className="col-12 col-lg-3 col-md-3 col-sm-6 float-left">
                                <label className="form-group text-center">
                                    Price
                                    <br />
                                    <input
                                        type="number"
                                        className="form-control text-center"
                                        name="price"
                                        disabled={true}
                                        value={parseInt(oi_items.oi_unit_price) * parseInt(oi_items.oi_qty)}

                                    />
                                </label>
                            </div>
                            <div className="col-12 col-lg-3 col-md-3 col-sm-6 float-left">
                                <label className="form-group text-center">
                                    Discount
                                    <br />
                                    <input
                                        disabled={true}
                                        name="discount"
                                        className="form-control text-center"
                                        value={oi_items.prom_discount}

                                    />
                                </label>
                            </div>
                            <div className="col-12 col-lg-3 col-md-3 col-sm-6 float-left">
                                <label className="form-group text-center">
                                    Net Price
                                    <br />
                                    <input
                                        className="form-control text-center"
                                        name="net_price"
                                        defaultValue={50}
                                        value={oi_items.oi_amount}
                                        disabled={true}

                                    />
                                </label>
                            </div>
                        </div>
                        <div className="row">
                            {/* <div className="col-lg-3 col-md-3 col-sm-6  col-xs-6">
                                <Button
                                    onClick={() => {
                                        setOi_items({
                                            ...oi_items,
                                            oi_prom_id: '',
                                            oi_prom_name: '',
                                            prom_name: '',
                                            oi_qty: '',
                                            oi_amount: '',
                                            prom_discount: '',
                                            prom_apply: false
                                        })
                                        forceUpdate();
                                    }}
                                    className="btn btn-primary btn-lg rBBtn"
                                    style={{ backgroundColor: AppColors.primary, borderWidth: 0, color: 'white', marginBottom: 10, fontFamily: 'PMe' }} >
                                    None
                                </Button>
                            </div> */}
                            {
                                promotions?.map((v, i) => {
                                    return (

                                        <div className="col-12  col-lg-12 col-md-12 col-sm-12 w-100">

                                            <Button
                                                onClick={() => {
                                                    let obj = v
                                                    // v.target.value
                                                    // obj = JSON.parse(obj);
                                                    var makeDiscountString;
                                                    if (obj.prom_type == 'fixed') makeDiscountString = "$" + obj.prom_amount;
                                                    else makeDiscountString = obj.prom_amount + "%"
                                                    console.log('makeDiscountString' + makeDiscountString)
                                                    setOi_items({
                                                        ...oi_items,
                                                        oi_prom_id: obj.prom_id,
                                                        prom_name: obj.prom_name,
                                                        oi_prom_name: obj.prom_name,
                                                        oi_qty: obj.prom_qty,
                                                        oi_amount: obj.prom_price,
                                                        prom_discount: makeDiscountString,
                                                        prom_apply: true
                                                    })

                                                    forceUpdate();
                                                }}
                                                className="btn btn-primary btn-lg rBBtn"
                                                style={{ backgroundColor: AppColors.primary, borderWidth: oi_items.oi_prom_id == v.prom_id ? 3 : 0, color: 'white', borderColor: 'rgba(0,0,0,0.5)', marginBottom: 10, fontFamily: 'PMe', borderStyle: "outside", fontSize: 14 }} >
                                                {v.prom_msg}
                                                {/* {v.prom_name} */}
                                                {/* <br />
                                                {v.prom_type == 'fixed' ? `$${v.prom_amount}` : `${v.prom_amount}%`} */}
                                            </Button>{" "}
                                        </div>
                                    )
                                })
                            }
                        </div>
                        {/* <p className="text-center">Any informat
                        ion/warning/msg here.</p> */}
                        <Button
                            onClick={() => {
                                addOrder()
                            }}
                            className="btn btn-primary btn-lg btn-group-justified rBBtn mt-5 "
                            style={{ backgroundColor: AppColors.primary, color: 'white', borderColor: AppColors.primary, marginBottom: 10, fontFamily: 'PMe' }} >
                            Order Now
                        </Button>
                    </div>
                </div>
            </div>
        </div>

    )
}


export default ReOrder

{/* <div>
                order item id =  {props.match.params.oi_id}
            </div>
            <div>cust id =  {props.match.params.cust_id}</div> */}
